/** Resuelve is_active para INSERT local (default: activo). */
export function resolveInsertIsActive(isActive?: boolean): 0 | 1 {
  return (isActive ?? true) ? 1 : 0;
}

export type ProductIvaRate = '21' | '10.5' | '27' | '0' | 'exento' | 'no_gravado';

const IVA_RATE_VALUES: ProductIvaRate[] = ['21', '10.5', '27', '0', 'exento', 'no_gravado'];

export function ivaRateToTaxClass(rate: string | null | undefined): string | null {
  const normalized = String(rate ?? '').trim();
  if (!normalized) return null;
  if (IVA_RATE_VALUES.includes(normalized as ProductIvaRate)) {
    return normalized;
  }
  return '21';
}

export function taxClassToIvaRate(taxClass: string | null | undefined): ProductIvaRate {
  const normalized = String(taxClass ?? '').trim();
  if (IVA_RATE_VALUES.includes(normalized as ProductIvaRate)) {
    return normalized as ProductIvaRate;
  }
  return '21';
}
